













import { AccessLevel } from '@/modules/access-policy/constants/access-levels.constants';
import { computed, defineComponent } from '@vue/composition-api';
import * as R from 'ramda';

export default defineComponent({
    name: 'AccessLevelDynamicBadge',
    props: {
        accessLevel: { type: String, required: true },
    },
    setup(props) {
        const accessLevelText = computed(() => {
            if (R.isNil(props.accessLevel)) return;

            switch (props.accessLevel) {
                case AccessLevel.Private:
                    return 'Visible to Only me';
                case AccessLevel.OrganisationLevel:
                    return 'Visible to My Organisation';
                case AccessLevel.SelectiveSharing:
                    return 'Selective Sharing';
                case AccessLevel.Restricted:
                    return 'Restricted Access within My Organisation';
                case AccessLevel.Public:
                    return 'Public Access';
                default:
                    return null;
            }
        });

        return {
            accessLevelText,
            AccessLevel,
        };
    },
});
